import React, { useEffect, useState, useMemo, useCallback } from 'react';
import {
  GoogleMap,
  Marker,
  DirectionsService,
  DirectionsRenderer,
} from '@react-google-maps/api';
import LocationForm from '../LocationForm';
import { useDispatch } from 'react-redux';

import * as S from './styles';
import { getRouteData } from 'sharedlibs/lib/redux/actions';
import { Loader } from '../MovemateLoader/styles';
import api from 'sharedlibs/lib/api';

const mapsOptions = {
  mapTypeControl: false,
  fullscreenControl: false,
  streetViewControl: false,
  keyboardShortcuts: false,
  mapTypeId: 'terrain',
};

const mapsStyles = {
  width: '100%',
  minHeight: '200px',
  height: '100%',
};

const MONTREAL_LAT_LNG = { lat: 45.54, lng: -73.65 };

export default function Map({ address, setAddress, editMode, ...props }) {
  const { canNext, handleNext } = props;
  const dispatch = useDispatch();
  const [routeResponse, setRouteResponse] = useState(null);
  const [position, setPosition] = useState(null);

  // NOTE: useEffect for get the User Geo Position by IP
  // If it has any issues, it uses Montreal Position
  useEffect(() => {
    async function getUserLocationByIP() {
      const { data } = await api.get('/location/');
      setPosition({ lat: data.latitude, lng: data.longitude });
    }
    try {
      getUserLocationByIP();
    } catch (error) {
      console.error('Error to get user location by IP', error);
      setPosition(MONTREAL_LAT_LNG);
    }
    return null;
  }, []);

  useEffect(() => {
    if (!address.pickup || !address.dropoff) {
      setRouteResponse(null);
    }
  }, [address.pickup, address.dropoff]);

  const directionsServiceOptions = useMemo(() => {
    if (address.pickup && address.dropoff) {
      const from = { coordinates: address.pickup.location };
      const to = { coordinates: address.dropoff.location };
      dispatch(getRouteData(from, to, editMode));
      return {
        origin: from.coordinates,
        destination: to.coordinates,
        travelMode: 'DRIVING',
      };
    }
  }, [address.pickup, address.dropoff, editMode]);

  const directionsCallback = useCallback((res) => {
    if (res !== null && res.status === 'OK') {
      setRouteResponse(res);
    }
  }, []);

  const directionsRendererOptions = useMemo(() => {
    return {
      directions: routeResponse,
    };
  }, [routeResponse]);

  if (!position) return <Loader />;

  return (
    <>
      <LocationForm
        position={position}
        address={address}
        setAddress={setAddress}
        canNext={canNext}
        handleNext={handleNext}
        invalidMessage={props.invalidMessage}
      />
      <S.Container className="mm-location-maps">
        <GoogleMap
          options={mapsOptions}
          mapContainerStyle={mapsStyles}
          center={position}
          zoom={10}
        >
          {address.pickup && !routeResponse && (
            <Marker position={address.pickup.location} />
          )}
          {address.dropoff && !routeResponse && (
            <Marker position={address.dropoff.location} />
          )}
          {address.pickup && address.dropoff && (
            <>
              <DirectionsService
                options={directionsServiceOptions}
                callback={directionsCallback}
              />
              {routeResponse && directionsRendererOptions && (
                <DirectionsRenderer options={directionsRendererOptions} />
              )}
            </>
          )}
        </GoogleMap>
      </S.Container>
    </>
  );
}
